import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../../assets/images/view/user2-160x160.jpg'


const _hoisted_1 = {
  class: "main-sidebar",
  id: "main-sidebar"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  id: "user-icon",
  style: {"cursor":"pointer"}
}, null, -1)
const _hoisted_3 = {
  class: "user-name",
  style: {"padding":"0"}
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 您好， ")
const _hoisted_5 = {
  class: "sidebar",
  style: {"height":"auto"}
}
const _hoisted_6 = { class: "sidebar-menu" }
const _hoisted_7 = ["data-menu-id"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/_createTextVNode()
const _hoisted_10 = {
  key: 0,
  class: "pull-right-container"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-angle-left pull-right" }, null, -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "treeview-menu menu-open" }
const _hoisted_14 = ["data-menu-id"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = /*#__PURE__*/_createTextVNode()

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    _createElementVNode("div", {
      class: "user-panel",
      onClick: _cache[1] || (_cache[1] = (...args) => ($options.userDetailEvent && $options.userDetailEvent(...args))),
      style: {"height":"120px"}
    }, [
      _createElementVNode("span", {
        class: "fa fa-sign-out user-sign-out",
        style: {"color":"rgb(238, 238, 255)","font-size":"18px"},
        onClick: _cache[0] || (_cache[0] = (...args) => ($options.signOut && $options.signOut(...args)))
      }),
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("span", null, _toDisplayString((_ctx.$Store.storeGet('user', true)||{}).name), 1)
      ])
    ]),
    _createElementVNode("section", _hoisted_5, [
      _createElementVNode("ul", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuData, (menu) => {
          return (_openBlock(), _createElementBlock(_Fragment, null, [
            (((menu.parentId == '' || menu.parentId == null)&&$options.hasAdmin(menu)||$options.hasCustom(menu)))
              ? (_openBlock(), _createElementBlock("li", {
                  class: "treeview",
                  "data-menu-id": menu.id,
                  key: menu.id
                }, [
                  _createElementVNode("a", {
                    onClick: $event => ($options.menuEvent(menu))
                  }, [
                    _createElementVNode("i", {
                      class: _normalizeClass(menu.icon)
                    }, null, 2),
                    _hoisted_9,
                    _createElementVNode("span", null, _toDisplayString(menu.name), 1),
                    (menu.route == '' || menu.route == null)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, _hoisted_12))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_8),
                  _createElementVNode("ul", _hoisted_13, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuData, (submenu) => {
                      return (_openBlock(), _createElementBlock(_Fragment, null, [
                        (submenu.parentId == menu.id&&$options.hasAdmin(submenu))
                          ? (_openBlock(), _createElementBlock("li", {
                              class: "treeview",
                              "data-menu-id": submenu.id,
                              key: submenu.id
                            }, [
                              _createElementVNode("a", {
                                onClick: $event => ($options.menuEvent(submenu))
                              }, [
                                _createElementVNode("i", {
                                  class: _normalizeClass(submenu.icon)
                                }, null, 2),
                                _hoisted_16,
                                _createElementVNode("span", null, _toDisplayString(submenu.name), 1)
                              ], 8, _hoisted_15)
                            ], 8, _hoisted_14))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 256))
                  ])
                ], 8, _hoisted_7))
              : _createCommentVNode("", true)
          ], 64))
        }), 256))
      ])
    ])
  ]))
}